import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import EtapaPCPModel from "@/models/pcp/etapaPCPModel";
import EtapaPCPService from "@/services/etapaPCPService";

import ListComponentBase from "../listComponentBase";

@Component
export default class EtapaListComponent extends ListComponentBase<EtapaPCPModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("descricao", this.$t("__.ts.descricao") as string, GridColumnType.String),
            new GridColumn("tipoDescricao", this.$t("__.ts.tipo") as string, GridColumnType.String),
            new GridColumn("ordem", this.$t("__.ts.ordem") as string, GridColumnType.String),
            new GridColumn("ativo", this.$t("__.ts.ativo") as string, GridColumnType.Boolean),
            new GridColumn("obrigatorio", this.$t("__.ts.obrigatorio") as string, GridColumnType.Boolean),
            new GridColumn(
                "origemEtapaDescricao",
                this.$t("__.Components.parent.venda.vendaForm_vue_html.origem") as string,
                GridColumnType.String,
            ),
        ];
    }

    private beforeMount() {
        this.setProps(new EtapaPCPService(), "etapaPCP", "descricao");
    }
}
